import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { appConfig } from '@config/app.config';
import { IconService } from '@core/services/icon.service';
import { AppService } from './core/services/app.service';
import { Router, RouterOutlet } from '@angular/router';
import { AsyncPipe, Location } from '@angular/common';
import { AnalyticsService } from './core/services/analytics.service';
import { SyncService } from './core/services/sync.service';
import { App as CapacitorApp } from '@capacitor/app';
import { NavigationComponent } from './navigation/navigation.component';
import { take } from 'rxjs/operators';
import { MatIcon } from "@angular/material/icon";
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [NavigationComponent, AsyncPipe, RouterOutlet, TranslatePipe, MatIcon, MatButtonModule],
    standalone: true
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly iconService = inject(IconService);
  private readonly translate = inject(TranslateService);
  private readonly appService = inject(AppService);
  private readonly analyticsService = inject(AnalyticsService);
  private readonly syncService = inject(SyncService);
  private readonly router = inject(Router);
  private readonly location = inject(Location);
  private readonly userId$ = this.appService.userId$;

  protected readonly textSize$ = this.appService.textSize$;
  protected readonly darkMode$ = this.appService.darkMode$;

  ngOnInit() {
    this.setupTranslationService();
    this.registerIcons();
    this.appService.updatePwa();
    this.listenToBackButtonOnNative();
    this.setupAnalytics();

    // If app is offline, try to get cached sync stuff
    if (!navigator.onLine) {
      this.syncService.tryOfflineSync();
    }

  }

  private setupAnalytics() {
    this.analyticsService.setDocumentTitleOnRouteChange();

    // Set user ID if not yet set. If already set send it to matomo.
    this.userId$
      .pipe(
        take(1)
      ).subscribe(userId => {
        if (!userId) {
          this.analyticsService.generateUserId();
        } else {
          this.analyticsService.setUserIdOnMatomo(userId);
        }
      });
  }

  private registerIcons() {
    this.iconService.registerIcons(appConfig.icons);
  }

  private listenToBackButtonOnNative() {
    CapacitorApp.addListener('backButton', ({canGoBack}) => {
      console.log('listenToBackButtonOnNative', );
      if(!canGoBack || this.router.url.endsWith('/station')){
        CapacitorApp.exitApp();
      } else {
        window.history.back();
      }
    });
  }


  private setupTranslationService() {
    this.translate.use(appConfig.language.defaultLocale);
    const persistedLanguage = 'de';
    if (persistedLanguage) {
      this.appService.setLanguage(persistedLanguage);
    } else {
      this.translate.use(appConfig.language.defaultLocale);
    }
  }

  protected goBack() {
    this.location.back();
  }

  protected get hideBackButtonOnSomeRoutes() {
    return this.router.url.endsWith('language-selection')
      || this.router.url.endsWith('/station')
      || this.router.url.endsWith('/');
  }

  ngOnDestroy() {
    this.analyticsService.stopSetDocumentTitleOnRouteChange();
  }

}
